<ng-container *transloco="let t">
  <div class="flex h-full flex-col">
    <div class="flex h-(--header-height) shrink-0 items-center justify-between gap-2 border-b px-5">
      @if (isSidebarCollapsed()) {
        <button
          iButton
          variant="ghost"
          size="icon-sm"
          [iTooltip]="t('page-title.expand_sidebar')"
          iTooltipPlacement="bottom"
          (click)="isSidebarCollapsed.set(!isSidebarCollapsed())"
          class="shrink-0"
        >
          <IIcon name="sidebarRight" />
        </button>
      }
      <div class="flex min-w-0 items-center">
        @if (subPage()) {
          <a
            iButton
            variant="ghost"
            class="text-muted-foreground shrink-0"
            [routerLink]="parentRouteUrl()"
            [queryParams]="{ preserve: true }"
            testId="previous-page"
          >
            {{ parentTitle() }}
          </a>
          <span class="text-subtle-foreground">/</span>
        } @else {
          <div class="type-body-medium px-2 py-1">{{ parentTitle() }}</div>
        }
        <div #breadcrumbPortalOutlet class="min-w-0"></div>
        <div>
          @if (title(); as title) {
            <app-breadcrumb-item [title]="t(title)" />
          }
        </div>
      </div>

      <div class="flex items-center">
        @if (withOrganizationSelector()) {
          <app-organization-selector />
        } @else if (withMultiAccountSelector()) {
          <app-multi-account-selector />
        } @else if (withAccountSelector()) {
          <app-account-selector />
        }
        @if (invalidAccountMarketplaces().length > 0) {
          <button iButton variant="warning" class="ml-2" (click)="requestGrant()">
            <IIcon name="fileLock" />
            {{ t("default-layout.grant_access") }}
          </button>
        }
      </div>

      <div class="flex flex-1 items-center justify-end gap-2">
        @if (withCurrencySelector()) {
          <app-currency-selection />
        }
        @if (withDatePicker()) {
          <app-date-range-selector />
        }
      </div>
    </div>
    @let suspendedOrg = suspendedOrganization();
    @if (suspendedOrg) {
      <IAlert
        class="m-4"
        type="error"
        [title]="
          isSuspensionEffective()
            ? t('suspension.access_suspended') + ' - ' + suspendedOrg.organizationName
            : t('suspension.your_access_will_be_suspended_on', {
                organizationName: suspendedOrg.organizationName,
                date: suspendedOrg.organization.suspensionDate | date: 'shortDate' : undefined : locale(),
              })
        "
      >
        @if (
          suspendedOrg.organization.accessLevel !== AccessLevel.ADMIN || suspendedOrg.organization.parentOrganizationId
        ) {
          {{ t("suspension.child_organization_message") }}
        } @else {
          @if (isSuspensionEffective()) {
            {{ t("suspension.access_suspension_description_1") }}
          } @else {
            {{ t("suspension.access_suspension_description_1_future") }}
          }
          <br />
          {{ t("suspension.access_suspension_description_2") }}
        }
      </IAlert>
    }

    <div class="relative min-h-0 flex-1" [class.pb-24]="withChatbotSafeMargin()" [class.p-5]="isPadded()">
      @if (loading() || overlay() === undefined) {
        <ISpinner [display]="true" withTitle main />
      } @else if (overlay(); as overlayComponent) {
        <ng-container *ngComponentOutlet="overlayComponent" />
      } @else {
        <ng-content></ng-content>
      }
    </div>
  </div>
</ng-container>
